module.exports = __webpack_public_path__ + "img/dots.5670aaa7.svg";